module.exports = function (notificationService) {
    return {
        restrict: 'E',
        scope: {
            name: '@?',
        },
        link(scope) {
            scope.notification = notificationService.registerNotficationTarget(scope.name);

            scope.closeNotification = notificationService.hideNotification.bind(notificationService, scope.name);
        },
        template: require('./notification.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/notification/notification.directive.js